import React, { useEffect, useState } from 'react';
import DealsLayout from '../DealsLayout/newIndex';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { getConfig } from '../../../../utils/config';
import Grid from '@splidejs/splide-extension-grid';
import { giftSvg } from '../../svg';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../../../store/auth-slice';
import { cmsClient, winnreAuth } from '../../../../utils/axios';
import { toast } from 'react-toastify';
import {
    useHistory,
    useLocation
} from 'react-router-dom/cjs/react-router-dom.min';
import ReactGA from 'react-ga4';
import TiTick from '@meronex/icons/ti/TiTick';
import GrClose from '@meronex/icons/gr/GrClose';
import PhoneNumber from '../PhoneNumber';
import Modal from '../../../../Components/Organisms/Modal';
import AiOutlineLeft from '@meronex/icons/ai/AiOutlineLeft';
import AiOutlineRight from '@meronex/icons/ai/AiOutlineRight';
import { BundleSvg } from './svg';

function BundleOffers({ bundleOffers }) {
    const config = getConfig();
    const [step, setStep] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [bundleLoading, setBundleLoading] = useState(false);
    const [bundleDealDetails, setBundleDealDetails] = useState([]);
    const [captureUserMobile, setCaptureUserMobile] = useState(false);
    const [bundleDealModal, setBundleDealModal] = useState(false);
    const [selectedOffers, setSelectedOffers] = useState([]);
    const [previousSelectedOffers, setPreviousSelectedOffers] = useState([]);

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const userId = useSelector((state) => state.auth.userId);
    const userMobile = useSelector(
        (state) => state.auth?.userDetails?.mobileNumber
    );
    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    // console.log('bundleOffers', bundleOffers);
    // console.log('bundleOffers', bundleOffers);
    const clickThroughMobile = clientWebview || internalWebview;
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const channel = queryParams.get('utm_medium');

    const handleCheckboxChange = (offer) => {
        // console.log("bundleOffer from deal&Discount" , offer );
        setSelectedOffers((prevSelected) => {
            const isSelected = prevSelected?.some(
                (item) => item.id === offer.id
            );

            if (isSelected) {
                return prevSelected?.filter((item) => item.id !== offer.id);
            } else {
                return [...prevSelected, offer];
            }
        });
    };

    // console.log('SelectedBundle Offers', selectedOffers);
    // console.log('selectedDea;Details', bundleDealDetails);

    const redeemSelectedDeals = (mobile) => {
        // setBundleDealDetails([]);
        // setShowModal(false);

        if (!isAuthenticated) {
            dispatch(authActions.openLoginModal());
            return;
        }
        if (!userMobile && !mobile) {
            setCaptureUserMobile(true);
            setShowModal(true);
            return;
        }
        setBundleLoading(true);
        // const selectedOffersIds = selectedOffers.map((offer) => offer.dealId);
        const selectedOffersIds = selectedOffers.map((offer) => offer.id);
        // console.log('selectedOffersIds', selectedOffersIds);
        let apiCall = Promise.all(
            selectedOffersIds?.map((id) =>
                winnreAuth({
                    method: 'GET',
                    url: `/winnre/user/deals/${id}`
                })
            )
        );
        setBundleLoading(true);
        apiCall
            .then((res) => {
                setBundleDealModal(false);
                setBundleDealDetails(res);
                setShowModal(true);
                setBundleLoading(false);
                setPreviousSelectedOffers([...selectedOffers]);
                setSelectedOffers([]);

                previousSelectedOffers?.forEach((offer) => {
                    window?.webengage?.track('RedeemSelectedDealClicked', {
                        DealId: `${offer?.id}`,
                        BrandName: `${offer?.vendorName}`,
                        Category: `${offer?.categoryName}`,
                        // Tags: `${offer?.Tags}`
                        Tags: `${offer?.tags?.map((tag) => tag?.name)}`
                    });
                });
            })
            .catch((err) => {
                toast.error('Something Went Wrong');
                setBundleLoading(false);
            });
    };

    const redeemAllClicked = (mobile) => {
        // setBundleDealDetails([]);
        // setShowModal(false);

        if (!isAuthenticated) {
            dispatch(authActions.openLoginModal());
            return;
        }
        console.log({ userMobile });
        if (!userMobile && !mobile) {
            setCaptureUserMobile(true);
            setShowModal(true);
            return;
        }
        setBundleLoading(true);
        const bundleIds = bundleOffers.map((offer) => offer.id);
        console.log(bundleIds);
        let apiCall = Promise.all(
            bundleIds?.map((id) =>
                winnreAuth({
                    method: 'GET',
                    url: `/winnre/user/deals/${id}`
                })
            )
        );
        setBundleLoading(true);

        apiCall
            .then((res) => {
                console.log('redeem All Clicked', res);
                setBundleDealDetails(res);
                setShowModal(true);
                setBundleLoading(false);
                for (const bundleDeal of bundleOffers) {
                    window?.webengage?.track('RedeemAllClicked', {
                        DealId: `${bundleDeal?.id}`,
                        BrandName: `${bundleDeal?.vendorName}`,
                        Tags: `${bundleDeal?.tags?.map((tag) => tag?.name)}`
                    });
                }
            })
            .catch((err) => {
                toast.error('Something Went Wrong');
                setBundleLoading(false);
            });
    };

    useEffect(() => {
        if (!showModal) {
            setStep(0);
        }
    }, [showModal]);

    console.log('selectedDealDetails', bundleDealDetails);

    const redeemAllBundleOffers = () => {
        if (
            cmsClient.defaults.baseURL === 'https://prod.loyalie.in' ||
            cmsClient.defaults.baseURL === 'https://uat.loyalie.in'
        ) {
            window.fbq('trackCustom', 'RedeemNowButtonClicked');
        }
        ReactGA.event({
            category: 'OFFER',
            action: 'REDEEM NOW CLICKED',
            label: 'REDEEM OFFER BUTTON'
        });

        const dealsToMap =
            previousSelectedOffers?.length > 0
                ? previousSelectedOffers
                : bundleOffers;

        const processDeals = (deals, res) => {
            let index = 0;
            const offers = bundleDealDetails;

            for (const deal of deals) {
                window?.webengage?.track('DealClicked', {
                    OfferName: `${deal?.title}`,
                    RedemptionType: `${deal?.redemptionType}`,
                    CashbackPercentage: `${deal?.eligibleCashback}`,
                    CouponCode: `${deal?.dealRedemptionCode}`,
                    Category: `${deal?.categoryName}`,
                    Vendor: `${deal?.vendorName}`,
                    Link: `${deal?.url}`,
                    EndDate: `${deal?.endDate}`,
                    Tags: `${deal?.tags?.map((tag) => tag?.name)}`,
                    DealId: `${deal?.id}`,
                    VoucherCode:
                        deal.dealType === 'OFFLINE'
                            ? ''
                            : deal?.redemptionType === 'VOUCHER' &&
                              res[index]?.status === 'SUCCESS'
                            ? res[index]?.dealCode
                            : res[index]?.status === 'FAILED' &&
                              res[index]?.message.includes('Repeat:')
                            ? res[index]?.message.split('Repeat:')[1]
                            : '',
                    ...(deal.redemptionType === 'VOUCHER' &&
                        deal.dealType === 'OFFLINE' && {
                            QRCode:
                                res[index]?.status === 'SUCCESS'
                                    ? res[index]?.dealQRCodeLink
                                    : res[index]?.status === 'FAILED'
                                    ? res[index]?.message.split('Repeat:')[1]
                                    : ''
                        }),
                    Channel: channel ? channel : 'Direct'
                });

                const offersIndex = offers.findIndex((o) => o.id === deal?.id);
                offers[offersIndex] = {
                    ...offers[offersIndex],
                    ...deal,
                    VoucherCode:
                        deal.dealType === 'OFFLINE'
                            ? ''
                            : deal?.redemptionType === 'VOUCHER' &&
                              res[index]?.status === 'SUCCESS'
                            ? res[index]?.dealCode
                            : res[index]?.status === 'FAILED' &&
                              res[index]?.message.includes('Repeat:')
                            ? res[index]?.message.split('Repeat:')[1]
                            : '',
                    ...(deal.redemptionType === 'VOUCHER' &&
                        deal.dealType === 'OFFLINE' && {
                            QRCode:
                                res[index]?.status === 'SUCCESS'
                                    ? res[index]?.dealQRCodeLink
                                    : res[index]?.status === 'FAILED'
                                    ? res[index]?.message.split('Repeat:')[1]
                                    : ''
                        })
                };
                index++;
            }
            return offers;
        };

        setBundleLoading(true);

        Promise.all(
            dealsToMap?.map((deal) =>
                winnreAuth({
                    method: 'POST',
                    url: `winnre/user/deals/redeem-v2?dealId=${
                        previousSelectedOffers?.length > 0 ? deal?.id : deal?.id
                    }&sourcePlatform=${
                        clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                    }${channel ? `&channel=${channel}` : ''}`
                })
            )
        )
            .then((res) => {
                const updatedOffers = processDeals(dealsToMap, res);
                const otherBundleOffers = bundleOffers.filter(
                    (offer) =>
                        !bundleDealDetails.some((deal) => deal.id === offer.id)
                );
                history.push({
                    pathname: '/bundleDetails',
                    state: {
                        offers: updatedOffers,
                        filteredOffers: otherBundleOffers
                    }
                });
                window?.webengage?.track('PdfViewed');
                setBundleLoading(false);
            })
            .catch((err) => {
                setBundleLoading(false);
                toast.error('Something Went Wrong');
            });
    };

    const handleViewAllBundleDeal = () => {
        history.push('dealListing?categoryID=8&categoryName=Bundle');
        return;
    };

    console.log('bundleOffers[0].tags[0].name', bundleOffers[0].tags[0].name);

    return (
        <>
            <div
                id="Housewarming"
                className="flex mt-8 lg:mt-16 mx-auto rounded-lg bg-[#F0F0F0] lg:p-6 xl:p-8"
            >
                <div
                    className="hidden lg:inline-flex lg:w-[25%] xl:w-[20%] text-white bg-cover rounded-l-lg bg-no-repeat"
                    style={{
                        backgroundImage:
                            'url("https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1713209956763_bundle%20offers")'
                    }}
                >
                    <div className="mx-auto mt-12">
                        {giftSvg}
                        {!config?.deals?.disableBundleDeals && (
                            <h1 className="text-2xl font-medium mt-2 tracking-wider w-full lg:w-1/3">
                                {bundleOffers.length > 0
                                    ? bundleOffers[0].tags[0].name.replace(
                                          'House Warming',
                                          'Housewarming'
                                      )
                                    : 'Housewarming Gifts'}
                            </h1>
                        )}
                        {config?.deals?.disableBundleDeals && (
                            <h1 className="text-2xl font-medium mt-2 tracking-wider w-full lg:w-1/3">
                                {'Housewarming Gifts'}
                            </h1>
                        )}
                        <button
                            onClick={() => {
                                if (!isAuthenticated) {
                                    dispatch(authActions.openLoginModal());
                                    return;
                                }
                                window?.webengage?.track(
                                    'MakeYourOwnGiftClicked',
                                    { UserId: `${userId}` }
                                );
                                setBundleDealModal(true);
                            }}
                            className="hidden lg:flex text-base lg:gap-[2px] xl:gap-1 mt-4 lg:px-3 xl:px-4 py-2 text-black rounded-lg bg-white"
                        >
                            {BundleSvg}
                            <span>Make Your Own Gift</span>
                        </button>
                    </div>
                </div>

                <div
                    className={`w-full lg:w-[75%] xl:w-[80%] ${
                        config?.sectionBackground?.color
                            ? 'bg-transparent'
                            : 'lg:bg-white'
                    } lg:rounded-r-lg`}
                >
                    <div className="p-3 md:p-5 lg:px-6 lg:py-3">
                        <div
                            className="flex lg:hidden justify-between items-center mb-5 cursor-pointer"
                            onClick={handleViewAllBundleDeal}
                        >
                            <div className="flex items-center">
                                {giftSvg}
                                {!config?.deals?.disableBundleDeals && (
                                    <h1 className="text-lg mt-2 ml-2">
                                        {bundleOffers[0]?.tags[0]?.name.replace(
                                            'House Warming',
                                            'Housewarming'
                                        ) || 'Housewarming Gifts'}
                                    </h1>
                                )}
                                {config?.deals?.disableBundleDeals && (
                                    <h1 className="text-lg mt-2 ml-2">
                                        {'Housewarming Gifts'}
                                    </h1>
                                )}
                            </div>
                            <button
                                className="text-primary underline"
                                onClick={handleViewAllBundleDeal}
                            >
                                View all
                            </button>
                        </div>
                        <button
                            onClick={() => {
                                window?.webengage?.track(
                                    'MakeYourOwnGiftClicked',
                                    {
                                        UserId: `${userId}`
                                    }
                                );
                                setBundleDealModal(true);
                            }}
                            className="lg:hidden w-full text-base flex justify-between items-center mt-4 py-3 text-black bg-white rounded-lg border-2 border-dashed px-4"
                        >
                            <div className="flex gap-1 md:gap-2 items-center">
                                {BundleSvg}

                                <span className="md:text-base">
                                    Make Your Own Gift
                                </span>
                            </div>
                            <div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8.73"
                                    height="16.008"
                                    viewBox="0 0 8.73 16.008"
                                >
                                    <path
                                        id="Right_Arrow_4_"
                                        d="M40.727,36.008a.728.728,0,0,1-.514-1.242L46.975,28l-6.762-6.762a.728.728,0,1,1,1.029-1.029l7.276,7.276a.727.727,0,0,1,0,1.029l-7.276,7.276A.725.725,0,0,1,40.727,36.008Z"
                                        transform="translate(-40 -20)"
                                        fill="#908f95"
                                    />
                                </svg>
                            </div>
                        </button>

                        <div className="relative">
                            <button
                                onClick={() => {
                                    const container =
                                        document.getElementById('BundleOffers');
                                    container.scrollTo({
                                        left: container.scrollLeft - 200,
                                        behavior: 'smooth'
                                    });
                                }}
                                className="hidden absolute -left-6 top-1/2 transform -translate-y-1/2 bg-white rounded-md py-[10px] px-[8px] z-10 lg:flex items-center justify-center shadow-md "
                            >
                                <AiOutlineLeft
                                    className="text-black"
                                    size={18}
                                />
                            </button>

                            <div
                                id="BundleOffers"
                                className="hidden lg:flex w-full gap-4 mt-4 overflow-x-scroll overflow-x-hidden"
                            >
                                {bundleOffers?.map((d, i) => {
                                    return (
                                        <DealsLayout
                                            key={i}
                                            id={d.id}
                                            title={d.title}
                                            endDate={d.endDate}
                                            thumbnailImageUrl={
                                                d.thumbnailImageUrl
                                            }
                                            displayImageUrl={d.displayImageUrl}
                                            vendorLogoUrl={d.vendorLogoUrl}
                                            className="w-[180px] md:w-[210px] lg:w-[260px]"
                                        />
                                    );
                                })}
                            </div>
                            <div
                                id="BundleOffers"
                                className=" flex flex-wrap lg:hidden gap-3 md:gap-4 w-full mt-4"
                            >
                                {bundleOffers?.slice(0, 4).map((d, i) => {
                                    return (
                                        <DealsLayout
                                            key={i}
                                            id={d.id}
                                            title={d.title}
                                            endDate={d.endDate}
                                            thumbnailImageUrl={
                                                d.thumbnailImageUrl
                                            }
                                            displayImageUrl={d.displayImageUrl}
                                            vendorLogoUrl={d.vendorLogoUrl}
                                            className="w-[47%] md:w-[210px]"
                                        />
                                    );
                                })}
                            </div>

                            <button
                                onClick={() => {
                                    const container =
                                        document.getElementById('BundleOffers');
                                    container.scrollTo({
                                        left: container.scrollLeft + 200,
                                        behavior: 'smooth'
                                    });
                                }}
                                className=" hidden absolute -right-2 top-1/2 transform -translate-y-1/2 bg-primary rounded-md py-[10px] px-[8px] z-10 lg:flex items-center justify-center "
                            >
                                <AiOutlineRight
                                    className="text-white"
                                    size={18}
                                />
                            </button>
                        </div>

                        <button
                            onClick={redeemAllClicked}
                            className="hidden text-center text-lg lg:flex justify-center from-yellow-400 bg-gradient-to-l to-[#FFA500] mt-4 px-8 py-2 text-white rounded-lg mx-auto"
                        >
                            Redeem All
                        </button>
                    </div>

                    <button
                        onClick={redeemAllClicked}
                        className="block lg:hidden w-full text-base mt-4  py-3 text-white rounded-b-lg bg-primary font-semibold"
                    >
                        Redeem All
                    </button>
                </div>
            </div>

            <Modal
                visible={bundleDealModal}
                onClick={() => setBundleDealModal(false)}
                className={`w-[90%] md:w-[55%] lg:w-[40%]`}
            >
                <div className="p-4">
                    <div className="flex justify-between items-center p-2">
                        <h1 className=" text-lg lg:text-2xl font-bold">
                            Make Your Own Gift
                        </h1>
                        <GrClose
                            onClick={() => {
                                setBundleDealModal(false);
                                setSelectedOffers([]);
                            }}
                            className={` h-5 w-5 cursor-pointer `}
                        />
                    </div>
                    <div className="overflow-y-auto">
                        {bundleOffers?.map((offer) => (
                            <div
                                onClick={() => handleCheckboxChange(offer)}
                                key={offer.id}
                                className="flex items-center gap-4 p-2 hover:bg-gray-100 rounded-md cursor-pointer"
                            >
                                <input
                                    type="checkbox"
                                    className="h-4 w-4 cursor-pointer"
                                    checked={selectedOffers?.some(
                                        (item) => item?.id === offer.id
                                    )}
                                />
                                <img
                                    src={offer.vendorLogoUrl}
                                    alt={offer.title}
                                    className="h-12 w-12 object-contain"
                                />
                                <span className="text-sm font-medium">
                                    {offer.title}
                                </span>
                            </div>
                        ))}
                    </div>
                    <button
                        onClick={redeemSelectedDeals}
                        className="mt-4 w-full bg-primary text-white py-2 rounded-md"
                    >
                        Redeem Selected Deals
                    </button>
                </div>
            </Modal>

            <Modal visible={showModal} onClick={() => setShowModal(false)}>
                <div className="flex justify-end px-4 ">
                    <GrClose
                        onClick={() => setShowModal(false)}
                        className={` h-5 w-5 cursor-pointer `}
                    />
                </div>
                {captureUserMobile && (
                    <PhoneNumber
                        // redeemNowClickedHandler={(mobile) =>
                        //     redeemAllClicked(mobile)
                        // }
                        redeemNowClickedHandler={(mobile) => {
                            if (selectedOffers.length > 0) {
                                redeemSelectedDeals(mobile);
                            } else {
                                redeemAllClicked(mobile);
                            }
                        }}
                        setCaptureUserMobile={setCaptureUserMobile}
                    />
                )}
                {!captureUserMobile && (
                    <div className="py-3 px-4 flex flex-col">
                        {step == '0' ? (
                            <>
                                <p className="font-semibold">
                                    By clicking on{' '}
                                    {previousSelectedOffers?.length > 0
                                        ? 'Redeem selected deal'
                                        : 'Redeem All'}
                                    , you agree & authorize Reloy and all
                                    partner brands part of this bundle deal to
                                    call you or contact you via various
                                    communication modes to assist you with your
                                    queries. This consent will override your
                                    DNC/NDNC registration if any.
                                </p>
                                <div className="flex justify-end mt-4 ">
                                    <button
                                        onClick={redeemAllBundleOffers}
                                        className="bg-[#154F9D1A] text-[#15509E] py-2 px-7 rounded"
                                    >
                                        {bundleLoading && showModal
                                            ? 'Loading...'
                                            : 'Agree'}
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="p-4 flex flex-col items-center justify-center">
                                <div className=" rounded-full mb-5 bg-green-500 p-2 md:p-4">
                                    <TiTick className=" text-white h-7 w-7 md:h-8 md:w-8" />
                                </div>
                                <h1 className="text-center">
                                    Thank you for redeeming the exciting offers
                                    part of this Housewarming Kit. You will be
                                    communicated the steps to redeem shortly.{' '}
                                </h1>
                            </div>
                        )}
                    </div>
                )}
            </Modal>
        </>
    );
}

export default BundleOffers;
